import axios from "axios";

import endpoints from "@/plugins/api/endpoints";

const actions = {
  async listProvince(context) {
    try {
      const endpoint = endpoints.common.provinces;
      const response = await axios[endpoint.method](
        `${process.env.API_BASE_URL}${endpoint.url}`,
      );
      const responseData = response.data.data;

      context.commit("mutationProvinces", responseData);
      return response;
    } catch (error) {
      context.commit("mutationProvinces", []);
      throw error;
    }
  },
};

export default actions;
